require('../modules/es.parse-int');
var path = require('../internals/path');

module.exports = path.parseInt;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/parse-int.js
// module id = 242
// module chunks = 0